<template>
  <router-link
    class="accommodation-card"
    :to="{
      name: 'foravila-accommodation-view',
      params: { slug: accommodation.slug },
    }"
  >
    <!-- Mobile: horizontal compact row -->
    <div class="accommodation-card-mobile d-flex d-sm-none align-items-center">
      <div class="accommodation-card-mobile__thumb flex-shrink-0">
        <img :src="accommodationPicture" :alt="accommodationName" />
      </div>
      <div class="accommodation-card-mobile__body flex-grow-1 px-3 py-2">
        <small v-if="accommodationSubtitle" class="accommodation-card-mobile__subtitle d-block mb-1">
          {{ accommodationSubtitle }}
        </small>
        <div class="accommodation-card-mobile__name font-weight-bold">
          {{ accommodationName }}
        </div>
        <small
          v-if="accommodationCity"
          class="text-uppercase letter-spacing-foravila font-weight-light text-muted"
        >
          {{ accommodationCity }}
        </small>
      </div>
      <feather-icon icon="ChevronRightIcon" size="16" class="text-muted flex-shrink-0 mr-2" />
    </div>

    <!-- Tablet and up: vertical card -->
    <b-card
      :img-src="accommodationPicture"
      img-top
      no-body
      class="hover-animate d-none d-sm-flex flex-column"
    >
      <b-card-body>
        <small v-if="accommodationName">
          {{ accommodationSubtitle }}
        </small>
        <b-card-title
          v-if="accommodationName"
          class="mb-0"
          :class="{ 'mt-3': accommodationSubtitle }"
        >
          {{ accommodationName }}
        </b-card-title>
        <small
          v-if="accommodationCity"
          class="text-uppercase letter-spacing-foravila font-weight-light"
        >
          {{ accommodationCity }}
        </small>
      </b-card-body>
    </b-card>
  </router-link>
</template>

<script>
  import { BCard, BCardBody, BCardTitle } from "bootstrap-vue";
  import FeatherIcon from "@core/components/feather-icon/FeatherIcon.vue";
  import { ACCOMMODATION_PLACEHOLDER_SM } from "@consts";
  import { getBathroomsText, getBedroomsText } from "@methods";

  export default {
    components: {
      BCard,
      BCardBody,
      BCardTitle,
      FeatherIcon,
    },
    props: {
      accommodation: {
        type: Object,
        required: true,
      },
    },
    computed: {
      accommodationName() {
        return this.accommodation?.name || null;
      },
      accommodationPicture() {
        return (
          this.accommodation?.coverPicture?.thumbnailUrl ||
          ACCOMMODATION_PLACEHOLDER_SM
        );
      },
      accommodationSubtitle() {
        const subtitle = [];

        if (this.accommodation.bedroomsNumber) {
          subtitle.push(
            getBedroomsText(
              this.accommodation.bedroomsNumber,
              this.$i18n.locale
            )
          );
        }
        if (this.accommodation.bathroomsNumber) {
          subtitle.push(
            getBathroomsText(
              this.accommodation.bathroomsNumber,
              this.$i18n.locale
            )
          );
        }
        return subtitle.length ? subtitle.join(" · ") : null;
      },
      accommodationCity() {
        return this.accommodation?.location?.city || null;
      },
    },
  };
</script>

<style lang="scss">
  .accommodation-card,
  .accommodation-card:hover {
    text-decoration: none;
    color: inherit;
  }

  .accommodation-card-mobile {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 10px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    transition: box-shadow 0.2s ease;

    &:active {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.14);
    }

    &__thumb {
      width: 90px;
      height: 70px;
      flex-shrink: 0;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        display: block;
      }
    }

    &__name {
      font-size: 0.9rem;
      line-height: 1.2;
    }

    &__subtitle {
      color: #888;
      font-size: 0.75rem;
    }
  }

  .card-img-top {
    border-bottom-left-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }
  .hover-animate {
    transition: all 0.2s ease-in-out;
    a {
      text-decoration: none;
      color: inherit;
    }
  }
  .hover-animate:hover {
    -webkit-transform: translate3d(0, -2px, 5px);
    transform: translate3d(0, -2px, 5px);
    cursor: pointer;
  }
</style>
